export default {
  created () {
    this.$ability = {}
    // if user has been authenticated, set
    if (this.$store && this.$store.getters['isAuthenticated']) {
      this.$ability = this.$store.getters['userPermissions']
    }
  },
  methods: {
    $allow (subject, operation = 'Read') {
      switch (operation.toLowerCase()) {
        case 'read':
          return this.$ability.canRead(subject)
        case 'write':
          return this.$ability.canWrite(subject)
        default:
          return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/rbacMixin.js